
export default function MilitaryDiscount() {
  return (
    <section className="relative py-16 bg-gradient-to-r from-[#1a1a1a] via-[#0a0a0a] to-[#1a1a1a] overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, #D4AF37 0, #D4AF37 1px, transparent 0, transparent 50%)',
          backgroundSize: '20px 20px'
        }}></div>
      </div>

      {/* Decorative Stars */}
      <div className="absolute top-1/2 left-8 -translate-y-1/2 opacity-20">
        <i className="ri-star-fill text-6xl text-[#D4AF37]"></i>
      </div>
      <div className="absolute top-1/2 right-8 -translate-y-1/2 opacity-20">
        <i className="ri-star-fill text-6xl text-[#D4AF37]"></i>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-[#D4AF37]/10 to-[#3D3225]/30 rounded-2xl border-2 border-[#D4AF37]/50 p-8 sm:p-12 text-center">
          {/* Badge */}
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#D4AF37] rounded-full mb-6 shadow-lg shadow-[#D4AF37]/30">
            <i className="ri-shield-star-fill text-4xl text-black"></i>
          </div>

          {/* Main Heading */}
          <h3 className="font-['Orbitron'] text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            <span className="text-[#D4AF37]">Military</span> & <span className="text-[#D4AF37]">First Responders</span>
          </h3>
          
          <div className="inline-block px-8 py-3 bg-[#D4AF37] rounded-lg mb-6">
            <span className="font-['Orbitron'] text-2xl sm:text-3xl font-bold text-black tracking-wider">
              DISCOUNT!
            </span>
          </div>

          <p className="text-gray-300 text-lg max-w-2xl mx-auto mb-8">
            We proudly support those who serve our community and country. Active duty military, veterans, 
            police officers, firefighters, and EMTs receive a special discount on all services.
          </p>

          {/* Icons Row */}
          <div className="flex items-center justify-center gap-6 sm:gap-10 mb-8">
            <div className="flex flex-col items-center gap-2">
              <div className="w-14 h-14 flex items-center justify-center bg-[#3D3225] rounded-xl">
                <i className="ri-user-star-line text-2xl text-[#D4AF37]"></i>
              </div>
              <span className="text-gray-400 text-sm">Military</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-14 h-14 flex items-center justify-center bg-[#3D3225] rounded-xl">
                <i className="ri-police-car-line text-2xl text-[#D4AF37]"></i>
              </div>
              <span className="text-gray-400 text-sm">Police</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-14 h-14 flex items-center justify-center bg-[#3D3225] rounded-xl">
                <i className="ri-fire-line text-2xl text-[#D4AF37]"></i>
              </div>
              <span className="text-gray-400 text-sm">Firefighters</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-14 h-14 flex items-center justify-center bg-[#3D3225] rounded-xl">
                <i className="ri-first-aid-kit-line text-2xl text-[#D4AF37]"></i>
              </div>
              <span className="text-gray-400 text-sm">EMTs</span>
            </div>
          </div>

          {/* CTA */}
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-black font-bold rounded-lg hover:bg-[#E5C158] transition-all hover:shadow-lg hover:shadow-[#D4AF37]/30 cursor-pointer whitespace-nowrap"
          >
            <span>Claim Your Discount</span>
            <i className="ri-arrow-right-line"></i>
          </a>

          <p className="text-gray-500 text-sm mt-4">
            Just mention your service when requesting a quote!
          </p>
        </div>
      </div>
    </section>
  );
}
